export const normalizeText = (value: string): string =>
  value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export const formatId = (id: string): string =>
  normalizeText(id.replace(/\s/g, '-'));
